import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Page, DatePicker, SubmitButton, FormGroup } from 'components/common';
import { Trans } from "react-i18next";
import { Col, Row, Modal, ModalHeader, Button, Table, Form, Input , Nav} from 'reactstrap';
import { Control, LocalForm } from 'react-redux-form';
import { useOrganisationContext } from "hooks";
import { ApiClient, } from "services";
import { NotificationManager } from "react-notifications";
import BackButton from 'components/refactoring/BackButton';
import { HoverCard } from "components";

const AuditFile = ({ match, t }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newYears, setNewYears] = useState([]);
    const [auditDateRange, setAuditDateRange] = useState({ from_date: '', to_date: '' });
    const [searchClicked, setSearchClicked] = useState(false);


    const { selectedOrganisation } = useOrganisationContext();  
    const client = ApiClient()



    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    useEffect(() => {
        fetchNewYearData();
      }, [selectedOrganisation.id]);

    const fetchNewYearData = async () => {
            try {
              const res = await client.get(`audit_reports/${selectedOrganisation.id}/add_year`);
              setNewYears(res.data);
            } catch (error) {
                NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
            }
          
    };

    const handleSaveNewYear = async (values) => {
            try {
              const res = await client.post(`audit_reports/${selectedOrganisation.id}/add_year`, values);
              toggleModal();
              fetchNewYearData();
              NotificationManager.success(t("Saved successfully"));
            } catch (error) {
                NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
            }
          
    };

    const handleSearch = (e) => {
        e.preventDefault();
        setSearchClicked(true);
    };

    const filteredYearsData = newYears?.filter(year => {
        if (!searchClicked) {
            return true;
        }
        const yearFromDate = new Date(year.from_date);
        const yearToDate = new Date(year.to_date);
        const start = auditDateRange.from_date ? new Date(auditDateRange.from_date) : new Date('2000-01-01');
        const end = auditDateRange.to_date ? new Date(auditDateRange.to_date) : new Date('2100-12-31');
        return yearFromDate >= start && yearToDate <= end;
    });

    const yearsData = filteredYearsData.length > 0 ? filteredYearsData : newYears;

    return (
        
        <Page title={t("Audit Reports")}>
            <BackButton />
            
            <Modal size="md" isOpen={isModalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}><Trans>Add New Year</Trans></ModalHeader>
                <div className="container">
                        <LocalForm onSubmit={handleSaveNewYear}>
                            <Row form className="mt-2">
                                <Col md={12}>
                                    <FormGroup label="Year Name">
                                        <Control.text
                                            model=".year_name"
                                            className="form-control"
                                            id="yearname"
                                            style={{ backgroundColor: '#F4F7FE' }}
                                            placeholder="e.g 2024"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form className="mt-2">
                                <Col md={6}>
                                    <FormGroup label="From">
                                        <DatePicker
                                            type="date"
                                            className="form-control"
                                            model=".from_date"
                                            placeholder="From Date"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup label="To">
                                        <DatePicker
                                            type="date"
                                            className="form-control"
                                            model=".to_date"
                                            placeholder="To Date"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="mt-3 mb-3" style={{ float: "right" }}>
                                <Button color="secondary" onClick={toggleModal}><Trans>Cancel</Trans></Button>{' '}
                                <SubmitButton>
                                        <Trans>Save</Trans>
                                </SubmitButton>
                            </div>
                        </LocalForm>
                </div>
            </Modal>
            <div className="m-auto">
            <Button className="mx-0 mb-3" style={{ backgroundColor: "#72B566", border: "none" }} onClick={toggleModal}>Add New Year</Button>
            <Row className="mb-3">
                <Col className="col-xs-12 col-md-12 pr-0">
                    <Form className="form" style={{ display: "flex" }} onSubmit={handleSearch}>
                        <FormGroup>
                            <label><Trans>Start Date</Trans></label>
                            <Input
                                type="date"
                                name="from_date"
                                className="col-xs-12 col-md-12 pl-3"
                                style={{ fontFamily: "FontAwesome, Arial", fontStyle: "normal" }}
                                value={auditDateRange.from_date}
                                onChange={(e) => setAuditDateRange({ ...auditDateRange, from_date: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup className="ml-2">
                            <label><Trans>End Date</Trans></label>
                            <Input
                                type="date"
                                name="to_date"
                                className="col-xs-12 col-md-12 pl-3"
                                style={{ fontFamily: "FontAwesome, Arial", fontStyle: "normal" }}
                                value={auditDateRange.to_date}
                                onChange={(e) => setAuditDateRange({ ...auditDateRange, to_date: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup label="&nbsp;">
                        <div className="ml-2 form-group ">
                            <Button color="success" type="submit"><Trans>Search</Trans></Button>
                        </div>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
            </div>
            <Table size="sm">
                <thead>
                    <tr>
                        <th className="text-center"><Trans>Year Name</Trans></th>
                        <th className="text-center"><Trans>From</Trans></th>
                        <th className="text-center"><Trans>To</Trans></th>
                        <th className="text-center"><Trans>Actions</Trans></th>
                    </tr>
                </thead>
                <tbody>
                    {yearsData.map((year) => (
                        <tr key={year.id}>
                            <td className="text-center ">
                                <Trans>{year.year_name}</Trans>
                            </td>
                            <td className="text-center ">
                                <Trans>{year.from_date}</Trans>
                            </td>
                            <td className="text-center ">
                                <Trans>{year.to_date}</Trans>
                            </td>
                            <td className="text-center">
                            <Link style={{ color: "#72b566" }} to={`audit_reports/audit_files/${year.id}`}>
                            <Button color="primary" size="sm"><Trans>Open</Trans></Button>
                            </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Page>
    );
};

export default AuditFile;
